/**
 * WARNING: Ce fichier est nécessaire au bon fonctionnement de l'app !
 * Ne pas renommer / déplacer / supprimer le fichier
 * Ne pas renommer ou supprimer les variables exportées
 * Suivre les commentaires dans le code pour éditer le fichier
 */
import { Router, useProcess } from '@fasstech/oip-starter-utils/app';
import views from '../views/client.js';
import Middle from './Middle.jsx';
import LayoutProvider from './providers/layout-provider';
import AnalyticsProvider from './providers/analytics-provider.jsx';
import { Layout } from './layout';
// added styles
import '@@app/css/main.css';
import '@fasstech/middle-design-system/index.css';
import { useEffect, useState } from 'react';
import { getMiddleFeatures } from '@fasstech/middle-client';

export const App = () => {
  const [middleFeatures, setMiddleFeatures] = useState(null);

  const { context } = useProcess();
  const { offerCode } = context;

  useEffect(() => {
    const fetchMiddleFeatures = async () => {
      const middleFeatures = await getMiddleFeatures(offerCode);
      setMiddleFeatures(middleFeatures);
    };

    if (offerCode) {
      fetchMiddleFeatures();
    }
  }, [offerCode]);

  return (
    <>
      <AnalyticsProvider middleFeatures={middleFeatures}>
        <LayoutProvider>
          <Middle middleFeatures={middleFeatures}>
            <Layout>
              <Router views={views} />
            </Layout>
          </Middle>
        </LayoutProvider>
      </AnalyticsProvider>
    </>
  );
};
